import { z } from 'zod';
import { partyRoleSchema } from '../../common';
import { nameSchema, objectIdSchema } from '../../validation';

/**
 * `Contact.clients[]` entry — link from a Contact to a `Client`
 * (the per-Org CRM ref).
 *
 * Each row says "this contact belongs to this Client", and carries a
 * full multi-role snapshot (`roles: PartyRole[]`) of the linked
 * Client at the time the link was made.
 */
export const contactClientSchema = z.object({
  /** the id of the Client this contact belongs to. */
  _id: objectIdSchema,
  /** the name of the Client this contact belongs to. */
  name: nameSchema,
  /**
   * the network roles the linked Client carries. Multi-valued — the
   * Hero platform is a network, not a marketplace, so a single Client
   * can be `business_customer` + `carrier_company` + `broker` at once.
   */
  roles: z.array(partyRoleSchema).min(1),
  /** is this contact the primary contact for the linked Client? */
  isPrimary: z.boolean(),
});

export type ContactClient = z.infer<typeof contactClientSchema>;
